import * as React from 'react';

/**
 * Class Printing displays the printing status
 */
const CheckAgain: React.FC = () => (
  <div className="cr-maple-200">
    <p className="cr-text-s cr-mv-0">
      Unable to detect the Zebra Browser Print application. Verify the following:
    </p>
    <ul className="cr-text-s cr-mb-0">
      <li>The Zebra Browser Print application is running on your computer</li>
      <li>
        The SSL certificate is trusted on{' '}
        <a
          className="notranslate"
          href="https://localhost:9101/available"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://localhost:9101/available
        </a>
      </li>
      <li>The domain is added inside the Accepted Hosts of Zebra Browser Print</li>
    </ul>
  </div>
);

export default CheckAgain;
